// Утилиты форматирования дат и периодов на русском.

const RU_WEEKDAYS = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота']
const RU_WEEKDAYS_SHORT = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб']
const RU_MONTHS = ['января','февраля','марта','апреля','мая','июня','июля','августа','сентября','октября','ноября','декабря']
const RU_MONTHS_NOM = ['январь','февраль','март','апрель','май','июнь','июль','август','сентябрь','октябрь','ноябрь','декабрь']

export function formatDate(iso: string): string {
  const d = new Date(iso)
  return `${d.getDate()} ${RU_MONTHS[d.getMonth()]}`
}

export function formatDateFull(iso: string): string {
  const d = new Date(iso)
  return `${d.getDate()} ${RU_MONTHS[d.getMonth()]} ${d.getFullYear()}`
}

export function formatDateTime(iso: string): string {
  const d = new Date(iso)
  const hh = String(d.getHours()).padStart(2, '0')
  const mm = String(d.getMinutes()).padStart(2, '0')
  return `${hh}:${mm}`
}

export function formatWeekday(date: Date): string {
  return RU_WEEKDAYS[date.getDay()]
}

export function formatWeekdayShort(date: Date): string {
  return RU_WEEKDAYS_SHORT[date.getDay()]
}

export function formatMonth(date: Date): string {
  return RU_MONTHS_NOM[date.getMonth()]
}

/** «20 мая 2026, среда» */
export function formatDateLong(date: Date): string {
  return `${date.getDate()} ${RU_MONTHS[date.getMonth()]} ${date.getFullYear()}, ${RU_WEEKDAYS[date.getDay()]}`
}

/** YYYY-MM-DD дедлайн → «через 3 дня» / «завтра» / «просрочено на 1 день». */
export function formatDeadline(deadline?: string | null): string {
  if (!deadline) return 'без срока'
  const d = new Date(deadline + 'T00:00:00')
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const diff = Math.round((d.getTime() - today.getTime()) / 86_400_000)
  if (diff < 0) return `просрочено на ${-diff} ${plural(-diff, 'день', 'дня', 'дней')}`
  if (diff === 0) return 'сегодня'
  if (diff === 1) return 'завтра'
  if (diff < 7) return `через ${diff} ${plural(diff, 'день', 'дня', 'дней')}`
  return `${d.getDate()} ${RU_MONTHS[d.getMonth()]}`
}

export function deadlineColor(deadline?: string | null): 'red' | 'orange' | 'green' | 'gray' {
  if (!deadline) return 'gray'
  const d = new Date(deadline + 'T00:00:00')
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const diff = Math.round((d.getTime() - today.getTime()) / 86_400_000)
  if (diff < 0) return 'red'
  if (diff <= 1) return 'orange'
  return 'green'
}

function plural(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return one
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few
  return many
}

export function todayISO(): string {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export function addDaysISO(days: number): string {
  const d = new Date()
  d.setDate(d.getDate() + days)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}
